import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=274f32b8&"
import script from "./Form.vue?vue&type=script&lang=js&"
export * from "./Form.vue?vue&type=script&lang=js&"
import style0 from "./Form.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('274f32b8', component.options)
    } else {
      api.reload('274f32b8', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=274f32b8&", function () {
      api.rerender('274f32b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Form/Form.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Form/Form.vue
// module id = RIsq
// module chunks = 0